export default "__VITE_ASSET__DEgmmPxP__"